import React from "react";
import {Text, usePatronTheme} from "@unibuddy/patron";
import {Link} from "ubcommunity-shared/src/General/Link/Link";

export const TermsAndConditions = () => {
    const theme = usePatronTheme();

    const linkStyle = {
        textDecorationLine: "underline",
        textDecorationColor: theme?.colors?.textLinkColor,
    };

    return (
        <Text size="small">
            By clicking 'Next' you agree to Unibuddy's{" "}
            <Link href="https://unibuddy.com/terms-of-use" style={linkStyle}>
                T&C's
            </Link>
            ,{" "}
            <Link href="https://unibuddy.com/acceptable-use-policy" style={linkStyle}>
                Acceptable Use Policy
            </Link>{" "}
            and{" "}
            <Link href="https://unibuddy.com/privacy-policy" style={linkStyle}>
                Privacy Policy
            </Link>
            .
        </Text>
    );
};
